import { render, staticRenderFns } from "./SelectOrCreateProfile.vue?vue&type=template&id=f2c97c18&scoped=true&"
import script from "./SelectOrCreateProfile.vue?vue&type=script&lang=js&"
export * from "./SelectOrCreateProfile.vue?vue&type=script&lang=js&"
import style0 from "./SelectOrCreateProfile.vue?vue&type=style&index=0&id=f2c97c18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c97c18",
  null
  
)

export default component.exports